<template>
  <div>
    <panel title="Powiadomienia">
      <w-table
        entity-type="message"
        :actions="actions"
        :show-checkboxes="false"
        :hide-search-input="true"
        :hide-add-button="true"
        :columns="columns"
        :data="list"
        :total="count"
        @view="view"
        @goToEntity="goToEntity"
      />
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { TableNameTranslations } from '@/enums/tableName';
import { listMixin } from '@/mixins/list';
import { GO_TO_MESSAGE_ENTITY_ACTION, VIEW_ACTION } from '@/utils/constants';
import { getSystemMessageEntityRoute } from '@/utils/getSystemMessageEntityRoute';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania powiadomień.',
  getError: 'Wystąpił błąd podczas pobierania danych powiadomienia.',
  added: 'Dodano powiadomienie.',
  addError: 'Nie udało się dodać powiadomienia.',
  updated: 'Zaktualizowano dane powiadomienia.',
  updateError: 'Nie udało się zaktualizować danych powiadomienia.',
  deleteConfirm: 'Czy na pewno chcesz usunąć powiadomienie?',
  deleted: 'Usunięto powiadomienie.',
  deleteError: 'Nie udało się usunąć powiadomienia.'
};

// @vuese
// Lista powiadomień
// @group message
export default {
  components: { Panel, WTable },
  mixins: [listMixin('systemMessage', messages, { visibilityDate: new Date() })],
  data: () => ({
    columns: [
      { name: 'visibilityDate', displayName: 'Data', sortable: true, minWidth: '15%', action: 'view' },
      { name: 'name', displayName: 'Nazwa', sortable: true, action: 'view' },
      { name: 'read', displayName: 'Przeczytano', sortable: true, minWidth: '15%' }
    ],
    actions: [VIEW_ACTION, GO_TO_MESSAGE_ENTITY_ACTION]
  }),
  computed: mapState({
    list: state =>
      state.systemMessage.list.map(message => {
        message.tooltipText = `Przejdź do ${TableNameTranslations[message.entityType]}`;
        return message;
      })
  }),
  methods: {
    // @vuese
    // Przechodzi do szczegółów powiadomienia
    view(message) {
      this.$router.push({ name: 'systemMessage', params: { messageId: message.id } });
    },
    // @vuese
    // Przechodzi do encji powiązanej z powiadomieniem
    goToEntity(message) {
      getSystemMessageEntityRoute(message.entityType, message.entityId)
        .then(route => this.$router.push(route))
        .catch(() => Errors.CANNOT_GO_TO_MESSAGE_ENTITY);
    }
  }
};
</script>
